import { render, staticRenderFns } from "./BeATrainer.vue?vue&type=template&id=995d8924"
import script from "./BeATrainer.vue?vue&type=script&lang=js"
export * from "./BeATrainer.vue?vue&type=script&lang=js"
import style0 from "./BeATrainer.vue?vue&type=style&index=0&id=995d8924&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports